import { safeAnyIgnoringPromise, safeSync } from '@src/utils/safe'

export type FireAndForgotTask = () => void | Promise<void>

export function executeFireAndForgotTask(task: FireAndForgotTask) {
  const id = setTimeout(safeAnyIgnoringPromise(task), 0)
  return safeSync(() => {
    clearTimeout(id)
  })
}
